BatchGeoStore.addReducer(
  "StoreLocator",
  {
    userLocation: null,
    visibility: true,
    locations: [],
    searchLocation: null,
  },
  {
    STORE_LOCATOR_LOCATIONS_UPDATE: function (state, action) {
      return Object.assign(state, {
        locations: action.locations,
      });
    },
    STORE_LOCATOR_VISIBILITY: function (state, action) {
      return Object.assign(state, {
        visibility: action.visibility,
      });
    },
    STORE_UPDATE_SEARCH_LOCATION: function (state, action) {
      return Object.assign(state, {
        searchLocation: action.searchLocation,
      });
    },
  },
);
